// Phase 43 CORRECTION (item 6 / D31-D33) — shared, NON-BLOCKING name typeahead
// advisory. Rendered beside the name inputs of every person-add modal; as the
// user types a name it surfaces live matches from two pools (item 5 substring
// match): the SAME-TYPE pool (possible DUPLICATE) and, for opponents /
// additional-opponents only, the archived-inclusive CLIENT pool (possible
// CONFLICT). Free text is never blocked — this only ADVISES; the save-time
// confirm (items 2/5) is the backstop. Advisory display (not a closed-list
// picker), so suggestions are informational chips, not selectable options.

import { nameText, findNameMatches } from "../lib/coiMatch.mjs";
import { RAD, FS } from "../lib/tokens";

const displayName = (c: any) =>
  c.companyName ||
  [c.firstName, c.lastName].filter(Boolean).join(" ") ||
  c.name ||
  "—";

export default function NameAdvisor({
  form,
  pool,
  coiPool,
  typeLabel,
  excludeId,
  t,
}: any) {
  const key = nameText(form);
  if (!key || key.length < 2) return null; // don't warn on a single character
  const cois = coiPool ? findNameMatches(form, coiPool, {}).slice(0, 6) : [];
  const dups = findNameMatches(form, pool || [], { excludeId }).slice(0, 6);
  if (!cois.length && !dups.length) return null;

  const renderBlock = (warn: any, rows: any, tone: any) => (
    <div style={{ marginTop: 2 }}>
      <div style={{ fontSize: FS.s9_5, fontWeight: 600, color: tone }}>{warn}</div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 3 }}>
        {rows.map((c: any) => (
          <span
            key={c.id}
            style={{
              fontSize: FS.s9_5,
              padding: "1px 6px",
              borderRadius: RAD.r8,
              background: "var(--bs)",
              color: "var(--tx)",
            }}
          >
            {displayName(c)}
          </span>
        ))}
      </div>
    </div>
  );

  return (
    <div
      className="field"
      style={{
        padding: "5px 8px",
        border: "1px solid var(--am)",
        borderRadius: RAD.r6,
        background: "var(--ams)",
        margin: "0 0 6px",
      }}
    >
      {cois.length > 0 &&
        renderBlock(
          t("party.warn.may_be_client", {
            fallback: "That adversary may have been a client",
          }),
          cois,
          "var(--rd)",
        )}
      {dups.length > 0 &&
        renderBlock(
          t("person.dup.exists", {
            type: typeLabel || "",
            fallback:
              "This person already exists" +
              (typeLabel ? " as " + typeLabel : ""),
          }),
          dups,
          "var(--am)",
        )}
    </div>
  );
}
